const autocompleteMaintenanceModalFilter = {
  sites: 'Sitios',
  equipments: 'Tipo de Equipo',
  place: 'Lugar',
  status: 'Status Mantenimientos',
  createdAt: 'Creado em',
  sendToMaintenanceDate: 'Fecha de Envió',
  returnFromMaintenanceDate: 'Fecha de Retorno',
  warranty: 'Plazo de Garantía',
  expiration: 'Plazo de Validez',
};

export default autocompleteMaintenanceModalFilter;
